import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/constants/testIds";
import { Phone } from "lucide-react";
import { telHref, PHONE } from "@/constants/site";
import Reveal from "@/components/Reveal";
import { useT } from "@/i18n/LanguageContext";

export default function FAQ_Section() {
  const { t } = useT();
  const faqs = t.faq.items;

  return (
    <section
      id="faq"
      data-testid={FAQ.section}
      className="relative bg-white py-16 sm:py-24 lg:py-32"
    >
      <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <Reveal direction="left" className="lg:col-span-5">
            <div className="overline text-[#1E63FF]">{t.faq.overline}</div>
            <h2 className="font-display font-semibold text-3xl sm:text-5xl lg:text-6xl tracking-tight text-[#0A0A0A] mt-4 leading-[1.02]">
              {t.faq.heading1}<br />
              <span className="text-neutral-400">{t.faq.heading2}</span>
            </h2>
            <p className="mt-6 text-neutral-600 text-base leading-relaxed">
              {t.faq.sub}
            </p>
            <a
              href={telHref}
              className="mt-8 btn-black h-12 px-6 rounded-full inline-flex items-center gap-2 text-sm font-semibold"
            >
              <Phone className="w-4 h-4" />
              {t.faq.callBtn} {PHONE}
            </a>
          </Reveal>

          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((item, i) => (
                <Reveal key={i} delay={i * 80}>
                  <AccordionItem
                    value={`item-${i}`}
                    data-testid={FAQ.item(i)}
                    className="border-b border-black/10"
                  >
                    <AccordionTrigger className="text-left font-display font-medium text-base sm:text-xl text-[#0A0A0A] py-5 hover:no-underline hover:text-[#1E63FF] tracking-tight">
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-neutral-600 text-base leading-relaxed pb-6 max-w-xl">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                </Reveal>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
